export default [
    false, true,
    "false", "true",
    0, 1,
    "0", "1",
    "f", "t",
    null, true,
    undefined, true
]; // odd: false, even: true